/* eslint-disable react/prop-types */
import React from 'react';

const InputCheckbox = ({
  name,
  label,
  style,
  checked,
  className,
  handleChange,
}) => (
  <>
    <label className={`mb-4${className ? ` ${className}` : ''}`} style={{ display: 'flex', alignItems: 'center', ...style }}>
      <input
        name={name}
        type='checkbox'
        checked={checked}
        onChange={handleChange}
        className='me-2 checkboxInput'
      />
      {label}
    </label>
  </>
);

export default InputCheckbox;
